const userProjects = [
  {
    id: 114,
    code: "MDV1006",
    legacyReference: null,
    legacyCode: null,
    name: "Ibrahim Nasir International Airport",
    state: "PCDCompleted",
    isActive: true,
    isRegionalProject: null,
    approvalDate: null,
    processingYear: null,
    category: null,
    country: {
      code: "MV",
      name: "Maldives",
    },
  },
  {
    id: "2333",
    code: "EGY0094",
    legacyReference: "EGT0094",
    legacyCode: "PJ___0016850",
    name: "South Helawn Power Plant Project",
    state: "OnDisbursement",
    profile: {
      id: "1",
      name: "Public Financing",
    },
    isActive: true,
    isRegionalProject: false,
    approvalDate: "2011-07-31",
    processingYear: 2011,
    category: "A",
    country: {
      code: "EG",
      name: "Egypt",
      state: "Active",
    },
  },
];

export default userProjects;
